import { render, staticRenderFns } from "./_messages.vue?vue&type=template&id=4c853198&scoped=true&lang=pug&"
import script from "./_messages.vue?vue&type=script&lang=js&"
export * from "./_messages.vue?vue&type=script&lang=js&"
import style0 from "./_messages.vue?vue&type=style&index=0&id=4c853198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c853198",
  null
  
)

export default component.exports